<div [id]="nodeId" class="chart line-bar">&nbsp;</div>

